import { Model } from "pinia-orm";

export default class Parcel extends Model {
  static entity = "parcels";
  static primaryKey = "uuid";

  static fields() {
    return {
      id: this.uid(""),
      uuid: this.uid(""),
      project: this.attr(null),
      parcelArea: this.number(0),
      parcelNumber: this.string(""),
    };
  }
}
